import UserAgentHelper from '@/utils/agentUtils';
import StorageHelper from '@/utils/storageHelper';

class GtmHelper {
  /**
   * Setup the constructor
   * @param {Object} userDetails  user details insider model
   * @param {Object} cookieSettings   user cookie settings
   */
  constructor(userDetails) {
    this.userDetails = userDetails;
    this.containerID = 'GTM-M2MN5QW';
  }

  addGTMStartEvent(dataLayer) {
    const gtmStartEvent = dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    dataLayer.push(gtmStartEvent);
  }

  initDataLayer(from, to) {
    var _self = this;
    if (window.dataLayer) {
      _self.pushVirtualPv(window.dataLayer, from, to);
    } else {
      try {
        // Google tag manager initialization
        (function(w, d, s, l, i) {
          w[l] = [];
          _self.pushVirtualPv(w[l], from, to);
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', _self.containerID);
      } catch (err) {
        console.error(err, 'Layout - Gtm, iProspect error');
      }
    }

    if (to.name === 'feed' && window.dataLayer) {
      let eventLog;
      let loginType = new StorageHelper({ id: process.env.VUE_APP_STORAGE_LOGIN_TYPE }).get();
      let userDetails = new StorageHelper({
        id: process.env.VUE_APP_STORAGE_CURRENT_USER_DETAIL,
      }).get();
      if (userDetails) {
        window.dataLayer.push({
          user_id: userDetails.uuid,
        });
      }
      if (loginType) {
        if (loginType === 'login_phone') {
          eventLog = { event: 'login', login_type: 'Telefon Numarasıyla' };
        } else if (loginType === 'login_first') {
          eventLog = { event: 'firstLogin_forgetPassword' };
        } else if (loginType === 'login_customer') {
          eventLog = { event: 'login', login_type: 'Bayi Koduyla' };
        } else if (loginType === 'login_vkn') {
          eventLog = { event: 'login', login_type: 'Vergi Kimlik Numarasıyla' };
        }
      }
      if (userDetails && !window.dataLayer.find(i => i.event === 'HQ_type')) {
        const { posChannel } = userDetails;
        eventLog = {
          event: 'HQ_type',
          posChannel,
        };
        if (eventLog) {
          window.dataLayer.push(eventLog);
        }
      }
    }
  }

  pushVirtualPv(dataLayer, from, to) {
    var _self = this;
    let clientInfo = new UserAgentHelper();
    const pos = new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).get();
    const loginType = new StorageHelper({ id: process.env.VUE_APP_STORAGE_LOGIN_TYPE }).get();
    let pladis = pos?.partners?.find(i => i.partnerName === 'PLADIS');
    let pladisPartnerCode = pladis?.partnerCode;
    var situationData = {
      event: 'commercial_data',
      page_type: to.name, //layoutModel.controllerName, //Sayfa tiplerini yapısal isimlendirebilirsiniz
      site_device_type: clientInfo.device, //Desktop, Mobile, Tablet ya da TV
      site_server:
        document && document.location && document.location.host ? document.location.host : null, //Site farklı serverlar üzerinden çalıştırılıyorsa o serverın bilgisi
      site_browser: clientInfo.browser, //Tarayıcı tipi
      site_os: clientInfo.OS, //İşletim sistemi - Windows, Android, iOS, Linux
      site_os_version: clientInfo.OsVersion, //İşletim sistemi versiyonu
      site_referrer: document.referrer || from.path, //siteye gelinen refferer domaini
      landing_page: '/auth/login/select', //sitede gelinen ilk sayfa
      site_browser_lang: window.navigator.language, //Sitenin açıldığı tarayıcının dili
      page_domain: window.location.origin,
      page_language: window.navigator.language,
      page_site_name: 'Pmaktif',
      page_site_region: 'tr',
      page_title: 'PMAKTIF',
      page_url: window.location.href,
      user_id: _self.userDetails.uuid,
      user_pos_channel: _self.userDetails.posChannel,
      site_type: 'desktop',
      visitor_type: 'visitor',
      login_method: loginType,
      New_PladisPartnerCode: pladisPartnerCode || null,
      device_type: clientInfo.device,
      order_currency: 'TRY',
      user_timestemp: new Date().toISOString(),
      'gtm.uniqueEventId': Math.floor(Math.random() * 1000),
    };

    dataLayer.push(situationData);
    if (dataLayer.length > 0 && !dataLayer.some(item => item?.hasOwnProperty('gtm.start'))) {
      this.addGTMStartEvent(dataLayer);
    }
  }
}
export default GtmHelper;
